export default __webpack_public_path__ + "static/media/trash_news_announcement.3bfe1849.svg";